import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { JsonLd, usePageSEO } from '../../components/seo/JsonLd';

export default function About() {
  usePageSEO(
    '会社概要 | 株式会社SUNFIELD',
    '株式会社SUNFIELDの会社概要、代表メッセージ、企業理念、沿革をご紹介。2023年設立の若い物流会社として、関西圏で安全・迅速・確実な輸送サービスを提供しています。',
    '会社概要,企業理念,代表メッセージ,沿革,SUNFIELD,物流会社,京都'
  );

  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "会社概要",
    "description": "株式会社SUNFIELDの会社概要、代表メッセージ、企業理念、沿革をご紹介",
    "url": `${import.meta.env.VITE_SITE_URL}/about`,
    "mainEntity": {
      "@type": "Organization",
      "name": "株式会社SUNFIELD",
      "foundingDate": "2023-09-01",
      "founder": {
        "@type": "Person",
        "name": "寸田翔馬",
        "jobTitle": "代表取締役"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "竹田藁屋町45 SOUBI BLD 2A",
        "addressLocality": "京都市伏見区",
        "addressRegion": "京都府",
        "postalCode": "612-8411",
        "addressCountry": "JP"
      }
    }
  };

  const companyInfo = [
    { label: '会社名', value: '株式会社SUNFIELD' },
    { label: '英文社名', value: 'SUNFIELD Transport Co., Ltd.' },
    { label: '設立', value: '2023年9月1日' },
    { label: '代表取締役', value: '寸田翔馬' },
    { label: '所在地', value: '京都府京都市伏見区竹田藁屋町45 SOUBI BLD 2A' },
    { label: '営業所', value: '〒614-8205 京都府八幡市戸津東代64−１' },
    { label: '電話', value: '090-9801-4659' },
    { label: '事業内容', value: '一般貨物運送事業・軽貨物運送事業' },
    { label: '営業時間', value: '8:00〜17:00（土日定休）' },
    { label: 'メール', value: 'sunfield.53@gmail.com' }
  ];

  const history = [
    { year: '2023/09', event: '株式会社SUNFIELD設立' },
    { year: '2023/09', event: '軽貨物運送事業開始' },
    { year: '2025/09', event: '一般貨物運送事業許可取得' },
    { year: '2025/09', event: '関西圏での配送ネットワーク構築' },
    { year: '2025/09', event: '協力会社との提携拡大' },
    { year: '2025/09', event: '安全管理体制の強化' }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: '安全第一',
      description: '徹底した安全管理と品質保証で、お客様の大切な荷物を確実にお届けします。'
    },
    {
      icon: 'ri-time-line',
      title: '迅速対応',
      description: '若手の機動力を活かし、お客様のニーズに迅速かつ柔軟に対応いたします。'
    },
    {
      icon: 'ri-handshake-line',
      title: '信頼関係',
      description: 'お客様との長期的な信頼関係を築き、共に成長するパートナーを目指します。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <JsonLd data={aboutPageSchema} />
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://public.readdy.ai/ai/img_res/91777b356a81c81816e2348e23916eb0.jpg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">会社概要</h1>
          <p className="text-xl text-blue-200">About SUNFIELD</p>
        </div>
      </section>

      {/* 代表メッセージ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
                代表メッセージ
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                株式会社SUNFIELDは、2023年に設立された新しい物流会社です。若手の力とフレッシュな発想で、従来の物流業界に新たな風を吹き込むことを目指しています。
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                「安全・迅速・確実」をモットーに、お客様の大切な荷物を心を込めてお運びします。関西圏を中心とした配送ネットワークを活用し、お客様のビジネスの成功に貢献できるよう、日々努力を重ねております。
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                これからも地域に根ざした信頼される物流パートナーとして、皆様のお役に立てるよう精進してまいります。
              </p>
              <div className="flex items-center">
                <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-white text-2xl"></i>
                </div>
                <div>
                  <p className="font-bold text-blue-900 text-lg">寸田翔馬</p>
                  <p className="text-gray-600">代表取締役</p>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/cc5acc468443f9f2e1d57f7e77c6fdd5.jpeg"
                alt="代表取締役 寸田翔馬"
                className="rounded-xl shadow-lg w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 企業理念 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              企業理念
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              安全・迅速・確実な輸送で社会に貢献し、お客様から信頼される物流パートナーを目指す
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow duration-300">
                <h3 className="text-xl font-bold text-blue-900 mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 会社情報 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-8">
                会社情報
              </h2>
              <div className="space-y-6">
                {companyInfo.map((info, index) => (
                  <div key={index} className="flex border-b border-gray-200 pb-4">
                    <dt className="w-32 font-semibold text-blue-900 flex-shrink-0">{info.label}</dt>
                    <dd className="text-gray-700 flex-1">{info.value}</dd>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-blue-900 mb-6">沿革</h3>
              <div className="space-y-6">
                {history.map((item, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-24 flex-shrink-0">
                      <span className="text-sm font-semibold text-blue-900 bg-blue-100 px-3 py-1 rounded-full">
                        {item.year}
                      </span>
                    </div>
                    <div className="ml-4">
                      <p className="text-gray-700">{item.event}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* アクセス */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              アクセス
            </h2>
            <p className="text-xl text-gray-600">
              〒614-8205 京都府八幡市戸津東代64−１
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6547.334844233766!2d135.7227701!3d34.8645831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60011afa942b0d57%3A0x140f2502a405d5e5!2z44CSNjE0LTgyMDUg5Lqs6YO95bqc5YWr5bmh5biC5oi45rSl5p2x5LujNjTiiJLvvJE!5e0!3m2!1sja!2sjp!4v1763473775471!5m2!1sja!2sjp"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg shadow-lg"
              ></iframe>
            </div>
            <div className="space-y-6">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h4 className="font-bold text-blue-900 mb-4 flex items-center">
                  <i className="ri-map-pin-line mr-2"></i>
                  所在地
                </h4>
                <p className="text-gray-700 mb-4">
                  <strong>本社</strong><br />
                  〒612-8411<br />
                  京都府京都市伏見区竹田藁屋町45 SOUBI BLD 2A
                </p>
                <p className="text-gray-700">
                  <strong>営業所</strong><br />
                  〒614-8205 京都府八幡市戸津東代64−１
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h4 className="font-bold text-blue-900 mb-4 flex items-center">
                  <i className="ri-phone-line mr-2"></i>
                  電話番号
                </h4>
                <p className="text-gray-700">
                  <a href="tel:090-9801-4659" className="text-blue-900 hover:text-blue-700 cursor-pointer">
                    090-9801-4659
                  </a>
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h4 className="font-bold text-blue-900 mb-4 flex items-center">
                  <i className="ri-time-line mr-2"></i>
                  営業時間
                </h4>
                <p className="text-gray-700">
                  8:00〜17:00（土日定休）
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h4 className="font-bold text-blue-900 mb-4 flex items-center">
                  <i className="ri-car-line mr-2"></i>
                  駐車場
                </h4>
                <p className="text-gray-700">
                  あり（お車でお越しの際はお気軽にご利用ください）
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            お気軽にお問い合わせください
          </h2>
          <p className="text-xl text-blue-200 mb-8">
            物流に関するご相談やお見積もりなど、どんなことでもお気軽にご連絡ください。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              お問い合わせ
            </Link>
            <Link
              to="/services"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-blue-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-truck-line mr-2"></i>
              サービス詳細
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
